import { render, staticRenderFns } from "./AppDivider.vue?vue&type=template&id=2b046eb5&scoped=true&"
import script from "./AppDivider.vue?vue&type=script&lang=js&"
export * from "./AppDivider.vue?vue&type=script&lang=js&"
import style0 from "./AppDivider.vue?vue&type=style&index=0&id=2b046eb5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b046eb5",
  null
  
)

export default component.exports